import React, { FC, useState, useEffect } from "react";
import { TableRowInput, TableRowDropdown } from "../Common";
import { HydronicControl as Model, BoolType } from "../../store/OJEUStore/models";

export interface HydronicControlProps {
    hydronicControl: Model,
    saveHydronicControl: (newHydronicControl: Model) => void
}

export const HydronicControl: FC<HydronicControlProps> = (props) => {
    const [hydronicControl, setHydronicControl] = useState(props.hydronicControl);

    const save = () => props.saveHydronicControl(hydronicControl);
    useEffect(() => {
        setHydronicControl(props.hydronicControl);
    }, [props.hydronicControl]);

    return (
        <table className="table table-sm mb-1">
            <tbody>
                <TableRowInput
                    name="Dew Point Safety Zone"
                    currentValue={hydronicControl.dewPointSafetyzone}
                    originalValue={props.hydronicControl.dewPointSafetyzone}
                    inputType="number"
                    minValue={0}
                    maxValue={8}
                    onSave={save}
                    onChange={newValue => setHydronicControl({ ...hydronicControl, dewPointSafetyzone: Number(newValue) })} />

                <TableRowDropdown
                    name="Dew Point Protect Enabled"
                    currentValue={Number(hydronicControl.dewPointProtectionEnabled)}
                    originalValue={Number(props.hydronicControl.dewPointProtectionEnabled)}
                    type={BoolType}
                    onChange={newValue => setHydronicControl({ ...hydronicControl, dewPointProtectionEnabled: !!newValue })}
                    onSave={save} />

                <TableRowDropdown
                    name="Valve Exercise Enabled"
                    currentValue={Number(hydronicControl.valveExerciseEnabled)}
                    originalValue={Number(props.hydronicControl.valveExerciseEnabled)}
                    type={BoolType}
                    onChange={newValue => setHydronicControl({ ...hydronicControl, valveExerciseEnabled: !!newValue })}
                    onSave={save} />

                <TableRowInput
                    name="Valve Exercise Time"
                    currentValue={hydronicControl.valveExerciseTime}
                    originalValue={props.hydronicControl.valveExerciseTime}
                    inputType="number"
                    minValue={7}
                    maxValue={28}
                    onSave={save}
                    onChange={newValue => setHydronicControl({ ...hydronicControl, valveExerciseTime: Number(newValue) })} />
            </tbody>
        </table>
    );
};
